<template>
  <transition name="fade">
    <BenchmarksTooltipWrapper
      v-if="show"
      :positionTop="positionTop"
      :positionLeft="positionLeft"
      :width="width"
    >
      <template v-slot:content>
        <BenchmarksTooltipContent
          :title="title"
          :content="content"
          :diff="diff"
          :theme="theme"/>
      </template>
    </BenchmarksTooltipWrapper>
  </transition>
</template>

<script>
import BenchmarksTooltipWrapper from './BenchmarksTooltipWrapper';
import BenchmarksTooltipContent from './BenchmarksTooltipContent';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    positionLeft: {
      type: Number,
      required: true,
    },
    positionTop: {
      type: Number,
      required: true,
    },
    width: {
      type: Number,
      default: 208,
    },
    title: {
      type: String,
      required: true,
    },
    content: {
      type: Array,
      default: () => [],
    },
    diff: {
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
  },
  components: {
    BenchmarksTooltipWrapper,
    BenchmarksTooltipContent,
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
